import sdl from '@jds/react-generated-sdl/JDSPaginationButton';
import type { JDSPaginationButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSPaginationButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { state = 'default', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { state, ...rest },
    'JDSPaginationButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const PaginationButton = withLogic(
  Component
) as React.FC<JDSPaginationButtonProps> & { slotName?: string };

PaginationButton.displayName = 'PaginationButton';
PaginationButton.slotName = 'jds_pagination_button';

export { PaginationButton, type JDSPaginationButtonProps };
